var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnvelopeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58579 8.58574L9.11612 8.05541L9.11611 8.05541L8.58579 8.58574ZM11.4142 8.58574L10.8839 8.05541L10.8839 8.05541L11.4142 8.58574ZM2 1.75H18V0.25H2V1.75ZM18.25 2V14H19.75V2H18.25ZM18 14.25H2V15.75H18V14.25ZM1.75 14V2H0.25V14H1.75ZM2 14.25C1.86193 14.25 1.75 14.1381 1.75 14H0.25C0.25 14.9665 1.0335 15.75 2 15.75V14.25ZM18.25 14C18.25 14.1381 18.1381 14.25 18 14.25V15.75C18.9665 15.75 19.75 14.9665 19.75 14H18.25ZM2 0.25C1.51696 0.25 1.07843 0.446697 0.762563 0.762563L1.82322 1.82322C1.86929 1.77716 1.93076 1.75 2 1.75V0.25ZM0.762563 0.762563C0.446697 1.07843 0.25 1.51696 0.25 2H1.75C1.75 1.93076 1.77716 1.86929 1.82322 1.82322L0.762563 0.762563ZM18 1.75C18.0692 1.75 18.1307 1.77716 18.1768 1.82322L19.2374 0.762564C18.9216 0.446695 18.483 0.25 18 0.25V1.75ZM18.1768 1.82322C18.2228 1.86928 18.25 1.93076 18.25 2H19.75C19.75 1.51696 19.5533 1.07843 19.2374 0.762564L18.1768 1.82322ZM8.05546 9.11607C9.1294 10.19 10.8706 10.19 11.9445 9.11607L10.8839 8.05541C10.3957 8.54357 9.60427 8.54356 9.11612 8.05541L8.05546 9.11607ZM0.762565 1.82323L8.05546 9.11607L9.11611 8.05541L1.82322 0.762562L0.762565 1.82323ZM11.9445 9.11607L19.2374 1.82323L18.1768 0.762561L10.8839 8.05541L11.9445 9.11607Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeWhite);
export default __webpack_public_path__ + "static/media/envelope-white.b062628a9569f6561bd5c81f90ac6b6c.svg";
export { ForwardRef as ReactComponent };